/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RecoveryLoginRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {RecoveryLoginResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const recoveryLogin = (request: RecoveryLoginRequest, options?: CashRequestOptions) => post<RecoveryLoginRequest, RecoveryLoginResponse>("/2.0/cash/recovery-login", request, {...options, rejectOnError: true })